import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import $common from '../assets/util'

Vue.use(Router)

import { baseUrl } from '../../config/index.js'


(function(){
	const URL_Mobile_RedirectPage = 'qrcode.html'
	
	// 前端预渲染的浏览器自动化调试时，不启用转跳
	if(window.location.hostname === 'localhost') {
		return
	}
	
	const isMobile = (() => {
		return (
			/Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
			|| screen.width <= 768
		)
	})()
	console.log('isMobile =>', isMobile)
	if(isMobile) {
		const { protocol, host } = window.location
		window.location.href = `${protocol}//${host}/${URL_Mobile_RedirectPage}`
	}
})()


const router = new Router({
	routes: [{
			path: '/',
			component: resolve => require(['../components/Common/Home.vue'], resolve),
			children:[
				{
					path: '/',
					name:'Index',
					component: resolve => require(['../components/index.vue'], resolve)
				},
				{
					path: '/index',
					name:'Index',
					component: resolve => require(['../components/index.vue'], resolve)
				},
				{
					path: '/my',
					name:'my',
					component: resolve => require(['../components/my.vue'], resolve)
				},
				{
					path: '/classify',
					name:'classify',
					component: resolve => require(['../components/classify/classify.vue'], resolve)
				},
				{
					path: '/warehouseGoodsList',
					name:'warehouseGoodsList',
					component: resolve => require(['../components/classify/warehouseGoodsList.vue'], resolve)
				},
				{
					path: '/searchResult',
					name:'searchResult',
					component: resolve => require(['../components/search/searchResult.vue'], resolve)
				},
				{
					path: '/productList',
					name:'productList',
					component: resolve => require(['../components/list/list.vue'], resolve)
				},
				{
					path: '/productDetail',
					name:'productDetail',
					component: resolve => require(['../components/product/productDetail.vue'], resolve)
				},
				{
					path: '/register',
					name:'register',
					component: resolve => require(['../components/register.vue'], resolve)
				},
				{
					path: '/login',
					name:'login',
					component: resolve => require(['../components/login.vue'], resolve)
				},
				{
					path: '/car',
					name:'car',
					component: resolve => require(['../components/car.vue'], resolve)
				},
				{
					path: '/order',
					name:'order',
					component: resolve => require(['../components/order/order.vue'], resolve)
				},
				{
					path: '/orderDetail',
					name:'orderDetail',
					component: resolve => require(['../components/order/orderDetail.vue'], resolve)
				},
				// {
				// 	path: '/logistics',
				// 	name:'logistics',
				// 	component: resolve => require(['../components/order/logistics.vue'], resolve)
				// },
				{
					path: '/confirmOrder',
					name:'confirmOrder',
					component: resolve => require(['../components/order/confirmOrder.vue'], resolve)
				},
				{
					path: '/collect',
					name:'collect',
					component: resolve => require(['../components/collect/collect.vue'], resolve)
				},
				{
					path: '/history',
					name:'history',
					component: resolve => require(['../components/my/history.vue'], resolve)
				},
				{
					path: '/address',
					name:'address',
					component: resolve => require(['../components/address/address.vue'], resolve)
				},
				{
					path: '/article',
					name:'article',
					component: resolve => require(['../components/article/article.vue'], resolve)
				}
			]
		},
		{
			path: '/404',
			component: resolve => require(['../components/common/404.vue'], resolve)
		},
		{
			path: '/403',
			component: resolve => require(['../components/common/403.vue'], resolve)
		},
		// {
		// 	path: '*',
		// 	redirect: '/404'
		// }
	],
	mode: 'history',
	base: baseUrl,
})

// #全局路由守卫

// 已刷新页面
let refreshed = true

// WARNING:
// sessionStorage生命周期为标签页关闭——至少chrome浏览器是这样
// 但window.open打开的新标签页会继承当前页的sessionStorage，
// 之后新标签页的sessionStorage独立于原标签页运行

// 刷新前的页面路径
const lastPage = sessionStorage.getItem('currentPage')
// 要在新标签页中打开的新路径，读取一次后销毁——避免当前标签页刷新后，路径变为最新的openPage的问题
const openPage = sessionStorage.getItem('openPage') || ''
sessionStorage.removeItem('openPage')

console.log(`
	页面刷新！
	刷新前的页面路径 => ${lastPage}
	要打开的新路径 => ${openPage}
`)

// 登录后页面黑名单
const preventPages = ['register', 'login']

router.beforeEach((to, from, next) => {
	// console.log(`beforeEach! from ${from.fullPath} to ${to.fullPath}`, from, to)
	
	// 载入刷新前的页面
	if(refreshed) {
		refreshed = false
		console.log('beforeEach: refreshed!')
		
		const userInfo = store.state.userInfo
		if(! userInfo.token) {
			
			// 微信登录重定向页面
			const resolveURLParams = function(url = window.location.href) {
				let URLParams = ''
				if(url.indexOf('?') > -1) {
					URLParams = url.split('?')
					URLParams = URLParams[URLParams.length - 1].split('&')
					let obj = {}
					for(let item of URLParams) {
						let [k, v] = item.split('=')
						obj[k] = v
					}
					URLParams = obj
					obj = null
				}
				return URLParams
			}
			const query = resolveURLParams()
			const wxLogin = {
				code: '',
				state: ''
			}
			if(typeof query === 'object' && query.code) {
				// console.log(query)
				Object.assign(wxLogin, {
					code: query.code,
					state: query.state || ''
				})
			}
			sessionStorage.setItem('wxLogin', JSON.stringify(wxLogin))
		}
		
		if(openPage && openPage !== baseUrl) {
			next(openPage)
			return
		}
		else if(lastPage && lastPage !== baseUrl) {
			next(lastPage)
			return
		}
		console.log('beforeEach: refreshed false!')
	}
	
	let nextOpts = true
	// 登录后禁止访问注册页和登录页
	if(preventPages.indexOf(to.name) > -1) {
		const userInfo = store.getters.userInfo
		if(userInfo.token) {
			// WARNING:
			// 此处可能会报错，但程序可以正常运行，路由也可以正确转跳
			// 例如：
			// Uncaught (in promise) Error: Redirected when going from "/order" to "/login" via a navigation guard.
			// 原因似乎是promise内抛出异常未被捕获，参考这篇文章：
			// https://blog.csdn.net/weixin_46873254/article/details/119358833
			// 这个错误不影响程序先不用管，其它地方出了问题找不到原因再考虑这里
			
			// 导航重定向到首页
			nextOpts = {
				replace: true,
				path: "/"
			}
		}
	}
	
	// 记录当前路由路径
	if(nextOpts === true) {
		sessionStorage.setItem('currentPage', to.fullPath)
	}
	else {
		sessionStorage.setItem('currentPage', baseUrl)
	}
	
	next(nextOpts)
})

// 路由守卫异常捕获
router.onError(function(){
	console.log('router.onError: args =>', arguments)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js